module.exports = __webpack_public_path__ + "img/mci_arrow-back.e38405ef.svg";